import { render } from "./CarouselCard.vue?vue&type=template&id=de8a5c9c"
import script from "./CarouselCard.vue?vue&type=script&lang=js"
export * from "./CarouselCard.vue?vue&type=script&lang=js"

import "./CarouselCard.vue?vue&type=style&index=0&id=de8a5c9c&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__